import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const problemSlice = createSlice({
    name: 'problem',
    initialState,
    // reducers: {},
})

export default problemSlice.reducer
